import { getNumberOfSelectedFilters } from '../lib/FilterLib';
import useSearchParams from './useSearchParams';

interface UseHasActiveFiltersParams {
  filterKeys: string[];
  ignoredKeys?: string[];
}

const useHasActiveFilters = ({ filterKeys, ignoredKeys }: UseHasActiveFiltersParams): boolean => {
  const { searchParams } = useSearchParams();

  return getNumberOfSelectedFilters(searchParams, filterKeys, ignoredKeys) > 0;
};

export default useHasActiveFilters;
